import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupHeaderLoadAction } from '../../domains/groupHeaderLoad/actions.types';

import type { GroupHeaderPermissions } from './types';

export type GroupHeaderPermissionsAction = GroupHeaderLoadAction;

const initialState: GroupHeaderPermissions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupHeaderPermissions, GroupHeaderPermissionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP_HEADER.LOAD_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'GROUP_HEADER.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'GROUP_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupHeaderPermissions);
    default:
      return state;
  }
};

export default reducer;
